"use client";

import { Box, Divider } from "@mui/joy";

import { CategoryNavigation } from "./CategoryNavigation";
import { Materials } from "./Materials";
import { useState } from "react";

export default function ListInventory() {
    const [selectedCategory, setSelectedCategory] = useState<any>(categories[0]);

    const handleCategoryChange = (categoryName: string) => {
        const selectedCategory = categories.find((e) => e.name === categoryName);
        setSelectedCategory(selectedCategory);
    };

    return (
        <Box display={"flex"} flex={1}>
            <CategoryNavigation categories={categories} onClick={handleCategoryChange} />
            <Divider orientation="vertical" />
            <Materials item={selectedCategory} />
        </Box>
    );
}
const categories = [
    {
        name: "Shingles",
        availableItems: 6,
        description: "Protective outer layer available in various materials.",
        subcategories: [
            "Architectural Shingles",
            "3-Tab Shingles",
            "Luxury/Designer Shingles",
            "Impact-Resistant Shingles",
            "Cool Roof Shingles",
            "Algae-Resistant Shingles",
        ],
        sampleItems: [
            {
                name: "Asphalt Architectural Shingles",
                description: "Durable laminated shingles with enhanced wind resistance.",
                size: "3-tab, 33.3 sq. ft. per bundle",
                unitPrice: 45,
                brand: "GAF",
                seller: "ABC Roofing Supplies",
                subcategory: "Architectural Shingles",
            },
            {
                name: "Metal Roofing Shingles",
                description: "Lightweight aluminum shingles with rust protection.",
                size: "4 ft x 1 ft panel",
                unitPrice: 75,
                brand: "CertainTeed",
                seller: "XYZ Roofing",
                subcategory: "Impact-Resistant Shingles",
            },
            {
                name: "Composite Shingles",
                description: "Synthetic blend designed for extreme durability.",
                size: "40 sq. ft. per bundle",
                unitPrice: 95,
                brand: "Brava",
                seller: "RoofTech",
                subcategory: "Luxury/Designer Shingles",
            },
            {
                name: "Wood Cedar Shingles",
                description: "Classic cedar shingles offering natural insulation.",
                size: "25 sq. ft. per bundle",
                unitPrice: 125,
                brand: "CedarWest",
                seller: "LumberYard",
                subcategory: "Luxury/Designer Shingles",
            },
            {
                name: "Slate Roof Tiles",
                description: "Premium natural stone tiles for longevity.",
                size: "10 in x 20 in",
                unitPrice: 200,
                brand: "Vermont Slate",
                seller: "LuxuryRoofing",
                subcategory: "Luxury/Designer Shingles",
            },
            {
                name: "Solar Reflective Shingles",
                description: "Cool roof shingles designed to reduce heat absorption.",
                size: "30 sq. ft. per bundle",
                unitPrice: 80,
                brand: "Owens Corning",
                seller: "EnergyRoofing",
                subcategory: "Cool Roof Shingles",
            },
        ],
    },
    {
        name: "Underlayment",
        availableItems: 4,
        description: "Waterproof layer placed beneath shingles.",
        subcategories: [
            "Synthetic Underlayment",
            "Felt Paper Underlayment",
            "Peel & Stick Underlayment",
            "Ice & Water Shield",
            "High-Temperature Underlayment",
        ],
        sampleItems: [
            {
                name: "Synthetic Roofing Underlayment",
                description: "Advanced water-resistant underlayment for all climates.",
                size: "4 ft x 250 ft roll",
                unitPrice: 25,
                brand: "Owens Corning",
                seller: "RoofMart",
                subcategory: "Synthetic Underlayment",
            },
            {
                name: "Felt Paper Underlayment",
                description: "Traditional asphalt-saturated underlayment for protection.",
                size: "36 in x 72 ft roll",
                unitPrice: 18,
                brand: "GAF",
                seller: "ABC Roofing Supplies",
                subcategory: "Felt Paper Underlayment",
            },
            {
                name: "Ice & Water Shield",
                description: "Self-adhering underlayment for leak protection.",
                size: "3 ft x 75 ft roll",
                unitPrice: 55,
                brand: "Grace",
                seller: "Premium Roofing",
                subcategory: "Ice & Water Shield",
            },
            {
                name: "High-Temperature Underlayment",
                description: "Designed for extreme heat applications.",
                size: "4 ft x 200 ft roll",
                unitPrice: 60,
                brand: "FireShield",
                seller: "RoofPro",
                subcategory: "High-Temperature Underlayment",
            },
        ],
    },
    {
        name: "Flashing",
        availableItems: 4,
        description: "Metal strips used to prevent water penetration.",
        subcategories: [
            "Step Flashing",
            "Drip Edge Flashing",
            "Valley Flashing",
            "Chimney Flashing",
            "Vent Pipe Flashing",
            "Kickout Flashing",
        ],
        sampleItems: [
            {
                name: "Step Flashing",
                description: "Pre-cut metal flashing for roof-to-wall connections.",
                size: "8 in x 14 in sheets",
                unitPrice: 30,
                brand: "MetalPro",
                seller: "BuildMart",
                subcategory: "Step Flashing",
            },
            {
                name: "Drip Edge Flashing",
                description: "Protects roof edges from water damage.",
                size: "2 in x 10 ft strips",
                unitPrice: 12,
                brand: "CertainTeed",
                seller: "RoofMart",
                subcategory: "Drip Edge Flashing",
            },
            {
                name: "Valley Flashing",
                description: "Used in roof valleys to channel water away.",
                size: "10 ft strip",
                unitPrice: 22,
                brand: "ABC Metals",
                seller: "LumberYard",
                subcategory: "Valley Flashing",
            },
            {
                name: "Chimney Flashing",
                description: "Waterproofing material for chimney bases.",
                size: "12 in x 12 in sheets",
                unitPrice: 40,
                brand: "Flashing Pro",
                seller: "BuildMart",
                subcategory: "Chimney Flashing",
            },
        ],
    },
    {
        name: "Gutters",
        availableItems: 3,
        description: "Channels that direct rainwater away from the roof.",
        subcategories: ["Seamless Gutters", "Vinyl Gutters", "Copper Gutters", "Steel Gutters", "Gutter Guards"],
        sampleItems: [
            {
                name: "Seamless Aluminum Gutters",
                description: "Rust-resistant aluminum gutters for efficient drainage.",
                size: "5 in x 10 ft",
                unitPrice: 10,
                brand: "Amerimax",
                seller: "Gutter World",
                subcategory: "Seamless Gutters",
            },
            {
                name: "Vinyl K-Style Gutters",
                description: "Durable vinyl gutters for low-maintenance homes.",
                size: "4 in x 8 ft",
                unitPrice: 8,
                brand: "RainMaster",
                seller: "BuildMart",
                subcategory: "Vinyl Gutters",
            },
            {
                name: "Copper Half-Round Gutters",
                description: "Premium aesthetic gutters with corrosion resistance.",
                size: "6 in x 10 ft",
                unitPrice: 85,
                brand: "Heritage Copper",
                seller: "LuxuryRoofing",
                subcategory: "Copper Gutters",
            },
        ],
    },
];
